import axios, { type AxiosInstance } from "axios";
import { getAccessToken } from "auth/session";
import { generateBaseUrl } from "./generateBaseUrl";

let apiClient: AxiosInstance | undefined;

export function createClient() {
  const client = axios.create({
    baseURL: generateBaseUrl(),
  });

  client.interceptors.request.use(async (config) => {
    const token = await getAccessToken();
    config.headers.set("Authorization", `Bearer ${token}`);
    return config;
  });

  return client;
}

export function getApiClient() {
  apiClient ??= createClient();
  return apiClient;
}

export function client() {
  return getApiClient();
}
